import type { Styles } from '@adornis/ass/style.js';
import type { Timeframe } from '@adornis/bh-timeframes/entities/Timeframe.js';
import type { Category } from '@adornis/buchungsheld-db/entities/category.js';
import type { ProductFilter } from '@adornis/buchungsheld-db/entities/products.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { getFilters } from './filter.js';

@customElement('bh-registration-product-filter')
export class BHRegistrationProductFilter extends ChemistryLitElement {
  @property({ attribute: false }) filter?: ProductFilter;
  @property({ attribute: false }) timeframes?: Timeframe[];
  @property({ attribute: false }) productTopics?: string[];
  @property({ attribute: false }) categories?: Category[];

  @state() readonly _translation = new TranslationController<BHTranslationDictionary>(this);

  override render() {
    const filter = this.filter;

    if (!filter) return nothing;

    return html`
      <x-flex vertical ${css({ gap: '7px' })}>
        <!-- search bar -->
        ${(() => {
          return html`
            <x-flex horizontal ${css({ position: 'relative' })}>
              <tr-input
                ${css({ width: '100%' })}
                value=${filter.description ?? ''}
                realPlaceholder=${this._translation.translate('search')}
                @value-changed=${e => this._dispatchUpdateFilterEvent('description', e.detail.value)}
                @keyup=${event => {
                  if (event.key === 'Enter') {
                    const value = event.target.value.value;
                    this._dispatchUpdateFilterEvent('description', value);
                  }
                }}
              ></tr-input>
              <tr-icon huge ${css({ position: 'absolute', right: '5px', top: '10px' })}>search</tr-icon>
            </x-flex>
          `;
        })()}

        <!-- filter-bar -->
        <bh-filter-bar
          .allFilters=${(() => {
            return getFilters({
              filter,
              translation: this._translation,
              availableTimeframes: this.timeframes,
              productTopics: this.productTopics,
              availableCategories: this.categories,
            });
          })()}
          .alwaysVisible=${['categoryIDs', 'languages', 'presences', 'hasFreeSeats']}
          @onSave=${e => this._dispatchUpdateFilterEvent(e.detail.key, e.detail.value)}
        ></bh-filter-bar>
      </x-flex>
    `;
  }

  private _dispatchUpdateFilterEvent(key: string, value: any) {
    this.dispatchEvent(
      new CustomEvent('update-filter', { detail: { value: { key, value } }, bubbles: true, composed: true }),
    );
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {},
      },
    ] as Styles[];
  }
}
